import { useState } from 'react';
import styled from 'styled-components';
import { BackTop } from 'antd';

import { EventOverviewHeader } from './header';
import { EventOverviewDesktop } from './overview.desktop';
import { EventOverviewMobile } from './overview.mobile';

import { useDeviceSize } from '../../../../hooks/device-size';
import type { Event } from '../../../../services/bb-api/event';

export const EventOverviewPage = () => {
	const [dataSource, setDataSource] = useState<(Event & { eventId: number })[]>([]);
	const [loading, setLoading] = useState(true);

	const isMobileDevice: boolean = useDeviceSize();
	const EventOverview = isMobileDevice ? EventOverviewMobile : EventOverviewDesktop;

	return (
		<Main>
			<EventOverviewHeader setDataSource={setDataSource} setLoading={setLoading} />
			<EventOverview dataSource={dataSource} loading={loading} />
			<BackTop target={() => document.querySelector('main') as any} />
		</Main>
	);
};

const Main = styled.main`
	display: flex;
	flex-direction: column;
	position: relative;
`;
